var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDummy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 438,
    viewBox: "0 0 347 438",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 347,
    height: 438,
    rx: 16,
    fill: "url(#pattern0_1140_2821)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1140_2821",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1140_2821",
    transform: "matrix(0.0197226 0 0 0.015625 -0.131124 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1140_2821",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAANZJREFUeF7t2sENxCAMBVGnWKqi2N0i5uADL/fIEsQzH5NvZn4TnnNOeHvm3pver/U/C+AL0AIYUChUIQSCLECDpQOntqAcIAgJQoKQIFQwXCksCG0HoXNOaoHtHaz1PwvgC9ACGFA0WCG0rVEQZAEWYAEWYIGwAjS4fJqrGyAHPJ8DTIVNhU2FUxDaPs3V+q7GQBAEQRAEw1ko/6BQszwLxD9VaZAGaZAG39bg8wMRC+BmyM1QguB2lK31jcVBEARBEATLQKRSuA40an0WYAEWYIGnLfAHGPOF8BnOgngAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummy2);
export default __webpack_public_path__ + "static/media/dummy2.853cfe71120b3f6037690b373fd430f8.svg";
export { ForwardRef as ReactComponent };